import { Layout } from "react-admin";
import { CustomAppBar } from "./custom-app-bar.component";
import { MenuJuristta } from "./menu";

const CustomLayout = (props) => {
    return <Layout {...props} appBar={CustomAppBar} menu={MenuJuristta} />
}

export default CustomLayout;
